import React from 'react';
import { Edit } from 'lucide-react';

export const EditCompanyModal = ({ editModal, setEditModal, companyEditForm, setCompanyEditForm, submitEditCompany, savingCompanyEdit }) => {
  if (!editModal) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" style={{position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 9999}}>
      <div className="modal-dark w-full max-w-lg">
        <div className="modal-dark-header flex items-center justify-between">
          <h3 className="font-bold text-lg flex items-center gap-2"><Edit className="w-5 h-5 text-cyan-400" /> Modifier l'entreprise</h3>
          <button onClick={() => setEditModal(null)} className="text-gray-400 hover:text-white">&#10005;</button>
        </div>
        <div className="p-6 space-y-3 max-h-[70vh] overflow-y-auto">
          {[
            { key: 'company_name', label: 'Nom entreprise', type: 'text' },
            { key: 'manager_name', label: 'Nom du gerant', type: 'text' },
            { key: 'email', label: 'Email', type: 'email' },
            { key: 'phone', label: 'Telephone', type: 'text' },
            { key: 'siret', label: 'SIRET', type: 'text' },
            { key: 'address', label: 'Adresse', type: 'text' },
            { key: 'new_password', label: 'Nouveau mot de passe (laisser vide si inchange)', type: 'password' },
          ].map(f => (
            <div key={f.key}>
              <label className="block text-xs text-gray-400 mb-1">{f.label}</label>
              <input
                type={f.type}
                value={companyEditForm[f.key] || ''}
                onChange={(e) => setCompanyEditForm({ ...companyEditForm, [f.key]: e.target.value })}
                className="input-dark w-full py-2"
                data-testid={`edit-company-${f.key}`}
              />
            </div>
          ))}
          <div className="flex gap-3 pt-4">
            <button onClick={() => setEditModal(null)} className="flex-1 py-3 rounded-xl bg-gray-700 hover:bg-gray-600 font-bold" data-testid="edit-company-cancel">Annuler</button>
            <button onClick={submitEditCompany} disabled={savingCompanyEdit} className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-700 font-bold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="edit-company-save">
              {savingCompanyEdit ? 'Sauvegarde...' : 'Enregistrer'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
